import React, { ChangeEvent, useEffect } from 'react'
import styles from '../styles.module.css'
import { MenuItem, TextField } from '@mui/material'
import { IUserPartial } from '../../../../app/entities/User'
import { isValidEmail } from '../../global/helper-functions/formValidation'
import LocationDropDown from '../../global/components/location-drop-down/LocationDropDown'
import { ROLES } from '../../global/constants/users'
import SpokeLocationDropDown from '../../global/components/spoke-location-drop-down/SpokeLocationDropDown'
interface IUserCreateProps {
  userData: IUserPartial
  setUserData: Function
  formError: boolean
  setFormError: Function
}

export default function UserCreate({
  userData,
  setUserData,
  formError,
  setFormError,
}: IUserCreateProps) {
  const { name, email, role } = userData
  const [locationValueOverride, setLocationValueOverride] = React.useState<
    string | null
  >(null)

  function handleChangeForm(e: ChangeEvent<HTMLInputElement>) {
    const { name, value } = e.target
    const updates = { ...userData, [name]: value }
    if (name === 'email' && !isValidEmail(value)) {
      setFormError(true)
    } else {
      setFormError(false)
    }

    // avoid setting locations for Admin and Super Admin
    const userChangedRole = name === 'role'
    if (userChangedRole) {
      updates['locations'] = []
      updates['spokeLocation'] = ''
      setLocationValueOverride(null)
    }

    setUserData({ ...userData, ...updates })
  }

  function onLocationChange(locationObjectId: string) {
    setUserData({
      ...userData,
      locations: [{ objectId: locationObjectId }],
    })
  }
  function onSpokeLocationChange(spokeLocation: string) {
    setUserData({
      ...userData,
      spokeLocation: spokeLocation,
    })
  }

  return (
    <div className={styles.formContainer}>
      <TextField
        value={name}
        onChange={handleChangeForm}
        label='Name'
        name='name'
        fullWidth
      />
      <TextField
        value={email}
        onChange={handleChangeForm}
        label='Email'
        name='email'
        error={formError}
        helperText={formError && 'Please enter a valid email address'}
        fullWidth
      />
      <RoleDropDown value={role} onChange={handleChangeForm} />
      {[ROLES.STORE_MANAGER, ROLES.STORE_REPRESENTATIVE].includes(
        role || '',
      ) && (
        <>
          <LocationDropDown
            onLocationChange={onLocationChange}
            defaultValue={userData.locations?.[0]?.objectId}
            valueOverride={locationValueOverride}
          />
          {userData.locations?.[0]?.objectId && (
            <SpokeLocationDropDown
              locationId={userData.locations?.[0]?.objectId}
              onSpokeLocationChange={onSpokeLocationChange}
              defaultValue={userData?.spokeLocation}
            />
          )}
        </>
      )}
    </div>
  )
}

const userRolesArray = Object.values(ROLES)
const RoleDropDown = ({ value, onChange }: any) => {
  const menuItems = userRolesArray.map((role, idx) => {
    return (
      <MenuItem key={idx} value={role}>
        {role}
      </MenuItem>
    )
  })
  return (
    <TextField
      label='Role'
      select
      name='role'
      fullWidth
      value={value}
      onChange={onChange}
    >
      {menuItems}
    </TextField>
  )
}
